export default {
  确认: "確認",
  取消: "キャンセル",
  选择语言: "言語を選択",
  切换语言成功: "言語の切り替えに成功しました",
  首页: "ホーム",
  报单: "申込",
  团队: "チーム",
  "交易进行中,请勿进行其他操作": "取引中です。他の操作はしないでください",
  资金管理: "資金管理",
  资金明细: "資金明細",
  我的订单: "マイオーダー",
  订单详情: "オーダー詳細",
  没有更多了: "これ以上ありません",
  加载中: "読み込み中",
  代币价格: "トークン価格",
  收益概览: "収益概要",
  申购收益: "申込収益",
  分享收益: "共有収益",
  官方网站: "公式ウェブサイト",
  官网: "公式サイト",
  电报: "Telegram",
  推特: "Twitter",
  白皮书: "ホワイトペーパー",
  申购金额: "申込金額",
  请输入入金金额: "入金金額を入力してください",
  快捷申购: "クイック申込",
  申购比例: "申込比率",
  赠币数量: "贈与トークン数量",
  立即申购: "今すぐ申込",
  更多: "もっと",
  订单: "オーダー",
  分红中: "配当中",
  已完成: "完了",
  累计分红: "累計配当",
  申购信息: "申込情報",
  兑换数量: "両替数量",
  赠币数量: "贈与トークン数量",
  开始时间: "開始時間",
  提现成功: "出金に成功しました",
  确认: "確認",
  订单编号: "オーダー番号",
  团队数据总览: "チームデータ概要",
  我的推广链接: "マイプロモーションリンク",
  复制: "コピー",
  "分享此链接邀请好友加入团队，获取推广奖励":
    "このリンクを共有して友達をチームに招待し、プロモーション報酬を獲得",
  团队业绩: "チーム業績",
  当前等级: "現在のランク",
  今日收益: "今日の収益",
  申购收益: "申込収益",
  分享收益: "共有収益",
  团队用户: "チームユーザー",
  有效团队: "有効チーム",
  有效用户: "有効ユーザー",
  无效团队: "無効チーム",
  直推用户: "直接紹介ユーザー",
  有效直推: "有効直接紹介",
  无效直推: "無効直接紹介",
  资产余额数据概览: "資産残高データ概要",
  提现: "出金",
  选中币种: "選択中の通貨",
  请输入入金金额: "入金金額を入力してください",
  提现数量: "出金数量",
  确认提现: "出金確認",
  资金明细: "資金明細",
  分红收入: "配当収入",
  直推奖励: "直接紹介報酬",
  团队奖励: "チーム報酬",
  申购金额: "申込金額",
  兑换数量: "両替数量",
  赠币数量: "贈与トークン数量",
  开始时间: "開始時間",
  立即申购: "今すぐ申込",
  确认: "確認",
  全部: "全て",
  收入: "収入",
  支出: "支出",
  请输入正确的金额: "正しい金額を入力してください",
  申购成功: "申込に成功しました",
  申购失败: "申込に失敗しました",
  提现失败: "出金に失敗しました",
  提现信息: "出金情報",
  提现币种: "出金通貨",
  提现数量: "出金数量",
  请选择币种: "通貨を選択してください",
  钱包余额不足: "ウォレット残高不足",
  余额不足: "残高不足",
  提现手续费: "出金手数料",
  间推奖励: "間接紹介報酬",
  团队奖励: "チーム報酬",
  提现失败退还: "出金失敗返金",
  ido申购: "IDO申込",
  ido申购赠送: "IDO申込贈与",
  链式去中心化全球点火网络: "チェーン型非中央集権型グローバル点火ネットワーク",
  协议永生: "プロトコル永生",
  智能涌现: "知能の出現",
  财富觉醒: "富の覚醒",
  立即进入: "今すぐ入る",
  大区累计业绩: "大エリア累計業績",
  小区累计业绩: "小エリア累計業績",
  复制成功: "コピーに成功しました",
  复制失败: "コピーに失敗しました",
  暂无数据: "データなし",
  当DeFi遇上自主型DAO: "DeFiが自律型DAOに出会うと",
  历史最高: "歴代最高",
  历史最低: "歴代最低",
  当前价格: "現在価格",
  报单累计收益: "申込累計収益",
  团队累计收益: "チーム累計収益",
  报单金额: "申込金額",
  快捷报单: "クイック申込",
  请输入报单金额: "申込金額を入力してください",
  报单比例: "申込比率",
  报单信息: "申込情報",
  进行中: "進行中",
  已完成: "完了",
  累计收益: "累計収益",
  立即报单: "今すぐ申込",
  请输入提现数量: "出金数量を入力してください",
  提现确认: "出金確認",
  "本次提现的链上Gas费需由您自行承担，点击确定将执行提现流程，届时提取的余额会被优先扣除":
    "今回の出金のチェーン上のGas料金はご自身で負担していただきます。確定をクリックすると出金フローが実行され、その際に引き出される残高が優先的に差し引かれます",
  "操作后无法撤销，请谨慎认购":
    "操作後は取り消せません。慎重に購入してください",
  我再想想: "もう一度考えます",
  确认提现: "出金確認",
  余额不足: "残高不足",
  直推奖励: "直接紹介報酬",
  团队奖励: "チーム報酬",
  提现失败退还: "出金失敗返金",
  平级收益: "同階層収益",
  每日释放: "毎日解放",
  提现TDL: "TDL出金",
  报单失败: "申込に失敗しました",
  绑定邀请人: "招待者をバインド",
  报单成功: "申込に成功しました",
  提现比例: "出金比率",
  入金支付说明: "入金支払い説明",
  "您的实际支付由两部分组成，根据当前支付比例计算":
    "実際の支払いは2つの部分で構成され、現在の支払い比率に基づいて計算されます",
  支付TDL数量: "TDL支払い数量",
  入金数量: "入金数量",
  TDL支付比例: "TDL支払い比率",
  "注：支付比例由平台设定，可能随时调整":
    "注：支払い比率はプラットフォームによって設定され、随時調整される可能性があります",
  我知道了: "わかりました",
  支付USDT数量: "USDT支払い数量",
  USDT支付比例: "USDT支払い比率",
  TDL实时价格: "TDLリアルタイム価格",
  请先连接TCC链: "まずTCCチェーンに接続してください",
  CUSD支付比例: "CUSD支払い比率",
  支付CUSD数量: "CUSD支払い数量",
  算力红利: "算力利益",
  "当DeFi遇上自主型DAO闲置算力共享": "DeFiが自律型DAOに出会うと、使用中ではない計算力を共有します",
  "全民节点分红智能涌现": "全ノードの配的に出現します",
  "闲置算力共享·全民节点分红": "使用中ではない計算力を共有し、全ノードの配当を受ける",
};
